import { Region, REGIONS } from 'constants/shop';
import { CollectionHandleKey } from '../handles';
import { getHandle } from './get-handle';

// DE first, so callers that only read the first entry keep the handle they read before.
const HANDLE_REGIONS: ReadonlyArray<Region> = [
  Region.DE,
  ...REGIONS.filter((region) => region !== Region.DE),
];

// get all related handles by collection key
export const getAllHandles = ({ key }: { key: CollectionHandleKey }): Array<string> => {
  return Array.from(new Set(HANDLE_REGIONS.map((region) => getHandle({ key, region }))));
};
